import { NgClass, NgIf } from '@angular/common';
import {
  Component,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  Renderer2,
  OnInit,
  OnDestroy
} from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
@Component({
  selector: 'app-custom-drawer',
  template: ` <div
    *ngIf="_drawerVisible"
    class="custom-drawer"
    [ngClass]="drawerWrapperClass"
  >
    <div class="drawer-header">
      <span>{{ title }}</span>
      <button (click)="closeDrawer()">X</button>
    </div>
    <div class="drawer-content" [ngClass]="drawerContentClass">
      <ng-content></ng-content>
    </div>
  </div>`,
  styles: [
    `
      .custom-drawer {
        position: absolute;
        top: 0;
        left: 0;
        width: 300px;
        height: 100%;
        background-color: white;
        box-shadow: -2px 0 5px rgba(0, 0, 0, 0.5);
        z-index: 10;
        overflow: hidden;
        //transform: translateX(100%);
        //transition: transform 300ms ease-in-out;
      }

      .custom-drawer.visible {
        transform: translateX(0);
      }

      .drawer-header {
        display: flex;
        justify-content: space-between;
        padding: 10px;
        background-color: #f5f5f5;
        border-bottom: 1px solid #ddd;
      }

      .drawer-content {
        padding: 10px;
      }
    `
  ],
  standalone: false
})
export class CustomDrawerComponent implements OnDestroy {
  @Input() title = '';
  _drawerVisible = false;
  @Input('visible') set drawerVisible(value: boolean) {
    this._drawerVisible = value;
    if (value) {
      this.documentClickListener = this.renderer.listen(
        'document',
        'click',
        this.onDocumentClick.bind(this)
      );
    } else {
      this.isFirstClick = true;
      if (this.documentClickListener) {
        this.documentClickListener();
      }
    }
  }
  get drawerVisible(): boolean {
    return this._drawerVisible;
  }
  @Input('wrapperClass') drawerWrapperClass? = '';
  @Input('contentClass') drawerContentClass? = '';
  @Output() readonly close: EventEmitter<void> = new EventEmitter();
  // @ViewChild('drawerContainer', { static: false }) drawerContainer!: ElementRef;

  @Input() container!: HTMLElement;
  private documentClickListener!: () => void;
  private isFirstClick = true;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  // ngOnInit(): void {
  //
  // }
  ngOnDestroy(): void {
    if (this.documentClickListener) {
      this.documentClickListener();
    }
  }
  openDrawer(): void {
    this.drawerVisible = true;
  }

  closeDrawer(): void {
    // this.drawerVisible = false;
    this.close.emit();
  }
  private onDocumentClick(event: MouseEvent): void {
    if (this.isFirstClick) {
      this.isFirstClick = false;
      return;
    }
    if (this.drawerVisible && !this.el.nativeElement.contains(event.target)) {
      this.closeDrawer();
    }
  }
}

